import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const AvatarIcon = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/Icon" {...props}>
      <path
        d="M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38Z"
        fill="#C2CDCC"
      />
      <path
        d="M26.4752 26.719C26.6065 26.719 26.7324 26.6674 26.826 26.5754C26.9195 26.4833 26.9731 26.3582 26.9752 26.227C26.9752 26.2157 26.9752 26.2043 26.9752 26.193C26.6452 22.601 22.9612 21.377 21.8362 21.28C21.0132 21.207 21.0002 20.545 21.0002 19.719C22.0642 18.4601 22.6847 16.8863 22.7662 15.24C22.7662 12.528 21.2222 10.719 19.0002 10.719C16.7782 10.719 15.2342 12.528 15.2342 15.24C15.3158 16.8863 15.9363 18.4601 17.0002 19.719C17.0002 20.545 16.9872 21.207 16.1632 21.279C15.0382 21.379 11.3552 22.6 11.0242 26.192C11.0168 26.3235 11.0616 26.4526 11.1489 26.5513C11.2361 26.65 11.3588 26.7102 11.4902 26.719H26.4752Z"
        fill="#2C2C2C"
      />
    </Icon>
  );
};
